<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import add from "./add";
import { VENDORS_PATH } from "../../../../path";
import axios from "axios";
import BankInfo from "@/views/pages/Dilfoods/Vendors/bank-info";
import TagRawMaterial from "./tag-raw-material";

export default {
  components: { Layout, PageHeader, add, BankInfo, TagRawMaterial },
  data() {
    return {
      title: "Vendors",
      items: [
        {
          text: "List",
        },
        {
          text: "Vendors",
          active: true,
        },
      ],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      search: "",
      selectedVendor: {},
      vendors: [],
      filter: [],
      fields: [
        "name",
        "email",
        "mobile_number",
        "gst",
        "address",
        "tag_raw_materials",
        "actions",
      ],
      current_page: 1,
    };
  },
  methods: {
    async getVendors() {
      try {
        let response = await axios.get(this.base_url + VENDORS_PATH.GET, {
          params: {
            page: this.current_page,
            search: this.search,
          },
        });
        if (response.data.status == true) {
          this.vendors = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async deleteData(d) {
      try {
        let response = await axios.post(this.base_url + VENDORS_PATH.DELETE, {
          id: d.id,
        });
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Vendor Deleted`,
            variant: "success",
            solid: true,
          });
          this.getVendors();
        }
      } catch (e) {
        this.$bvToast.toast("Failed to delete", {
          title: e.message,
          variant: "error",
          solid: true,
        });
        console.log(e);
      }
    },
    addVendor() {
      this.selectedVendor = {};
      this.$bvModal.show("bv-add-vendor");
    },
    setEdit(d) {
      this.selectedVendor = d;
      this.$bvModal.show("bv-add-vendor");
    },
    reload() {
      this.getVendors();
    },
    setBankDetails(v) {
      try {
        this.selectedVendor = v;
        this.$bvModal.show("bv-set-vendor-bank-info");
      } catch (e) {
        console.log(e);
      }
    },
    setRawMaterials(v) {
      try {
        this.selectedVendor = v;
        this.$bvModal.show("bv-tag-raw-material");
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getVendors();
  },
  watch: {
    current_page() {
      this.getVendors();
    },
    search() {
      this.getVendors();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addVendor" class="btn btn-primary mb-10 pb-10"
                  >Add Vendor</b-button
                >
                <b-modal
                  id="bv-add-vendor"
                  :title="
                    (Object.keys(selectedVendor).length > 0 ? 'Edit' : 'Add') +
                    ' Vendor'
                  "
                  size="lg"
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selectedVendor="selectedVendor"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-tag-raw-material"
                  title="Raw Materials"
                  size="lg"
                  hide-footer
                >
                  <tag-raw-material :vendor="selectedVendor">
                  </tag-raw-material>
                </b-modal>
                <b-modal
                  id="bv-set-vendor-bank-info"
                  size="xl"
                  title="Bank Info"
                  hide-footer
                >
                  <bank-info
                    @update="reload()"
                    :key="key"
                    :selectedVendor="selectedVendor"
                  ></bank-info>
                </b-modal>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <!-- End search -->
            <div class="table-responsive mb-0">
              <b-table
                :key="vendors.key"
                :items="vendors.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(actions)="row">
                  <b-button
                    class="mr-2"
                    @click="setBankDetails(row.item)"
                    variant="primary"
                    v-b-tooltip:hover
                    title="Set Bank Details"
                  >
                    <i class="fa fa-address-book"></i>
                  </b-button>
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
                <template v-slot:cell(tag_raw_materials)="row">
                  <b-button @click="setRawMaterials(row.item)">
                    <i class="fa fa-list"></i>
                  </b-button>
                </template>
                <template v-slot:cell(address)="row">
                  {{ row.item.address }}, <br />
                  {{ row.item.city }} ,<br />
                  {{ row.item.state }} ,<br />
                  {{ row.item.country }}
                </template>
              </b-table>
            </div>
            <!-- pagination -->
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      :key="vendors.key"
                      v-model="current_page"
                      :total-rows="vendors.total"
                      :per-page="vendors.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
